import { IntegrityMonitorRuleSetFormBaseDataProvider } from './IntegrityMonitorRuleSetFormBaseDataProvider';
import { sanitizeObject } from '../../../../utils/sanitization.utils';
import { RuleSetData } from '../types';

export class IntegrityMonitorRuleSetFormGzDataProvider extends IntegrityMonitorRuleSetFormBaseDataProvider {
  public async getRuleSetData(ruleSetId: string): Promise<RuleSetData> {
    const result = await this.dependencies.api.clients.IntegrityMonitorRuleSets.getCustomRuleSetNameAndDescription(
      ruleSetId
    ).toPromise();

    if (!result || !result.success) {
      throw new Error('Invalid response of getRuleSet');
    }

    return sanitizeObject(result.data);
  }

  public async updateRuleSet(record: Object): Promise<Object | null> {
    try {
      const response =
        await this.dependencies.api.clients.IntegrityMonitorRuleSets.updateCustomRuleSetNameAndDescription(
          record
        ).toPromise();

      return sanitizeObject(response);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  public async createRuleSet(record: Object): Promise<Object | null> {
    try {
      const response = await this.dependencies.api.clients.IntegrityMonitorRuleSets.createCustomRuleSetWithRules(
        record
      ).toPromise();

      return sanitizeObject(response);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
